<template>
    <div>
        <RebookableBadge
            v-if="product.IsRebookable"
            size="l"
            class="flight-modal-details-badge" />

        <Passengers :product="product" />

        <Divider color="lightGrey" bottomMargin="xxl" topMargin="xxl" thickness="1" />

        <Journeys
            type="Flight"
            direction="column"
            :legs="product.Legs"
            :showDetailed="true"
            :showHeaderBackground="false"
            :showHeader="product.Legs.length > 1" />

        <template v-if="brandedAttributes.length > 0">
            <Divider color="lightGrey" bottomMargin="xxl" topMargin="xxl" thickness="1" />

            <BrandedFareAttributes
                :attributes="brandedAttributes"
                :title="product.BrandedFare?.BrandName" />
        </template>
    </div>
</template>
<script lang="ts">
    import { defineComponent, PropType, computed } from 'vue';
    import { FlightProduct } from '@/api/Cart/cart.interfaces';
    import { mapBrandedFareAttributes } from '@shared/helpers/brandedFares';
    import { FlightBrandedAttributeStatus } from '@shared/interfaces/brandedFares';
    import Journeys from '@/components/shared/Journey/Journeys.vue';
    import RebookableBadge from '@/components/shared/RebookableBadge/RebookableBadge.vue';
    import Passengers from './Passengers/Passengers.vue';
    import Divider from '@ui/components/Divider/Divider.vue';
    import BrandedFareAttributes from '@ui/components/BrandedFares/BrandedCard/Attributes/Attributes.vue';

    export default defineComponent({
        name: 'FlightModalDetails',
        components: {
            RebookableBadge,
            BrandedFareAttributes,
            Journeys,
            Passengers,
            Divider,
        },
        props: {
            product: {
                type: Object as PropType<FlightProduct>,
                required: true,
            },
        },
        setup(props) {
            const brandedAttributes = computed(() => {
                const validStatuses = [
                    FlightBrandedAttributeStatus.Included,
                    FlightBrandedAttributeStatus.Chargeable,
                ];

                const attributes = mapBrandedFareAttributes({
                    dataType: 'checkout',
                    attributes: props.product?.BrandedFare?.Attributes ?? [],
                    flightLegs: props.product.Legs,
                });

                return attributes.filter((a) => validStatuses.includes(a.status));
            });

            return { brandedAttributes };
        },
    });
</script>
<style lang="scss" scoped>
    @forward 'Details';
</style>
